import React, {Component} from 'react';
import "./style.sass"
import "./index-style.css"
import Login from "../../components/login/login";
import Insert from "../../components/product/insert/insert";
import Update from "../../components/product/update/update";
import FirebaseContext from "../../components/Firebase/context";
import {Menu, Icon} from 'antd';
import Loader from "../../components/commons/Loader/loader";


class Root extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current: 'upload',
            email: '',
            password: '',
            user: {},
            submitted: false,
            error: '',
            step: 0,
            loading: true,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        if (sessionStorage.getItem('UID') !== null && sessionStorage.getItem('UID') !== undefined) {
            this.setState({step: 1, loading: false})
        }else{
            this.setState({loading: false})
        }

    }

    handleClick = e => {
        console.log('click ', e);
        this.setState({
            current: e.key,
        });
    };

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({disabled: true});
        const {email, password, step} = this.state;

        if (email.trim() === '' || password.trim() === '') {
            this.setState({submitted: true, disabled: false, error: ''});
        } else {
            this.setState({loading: true});
            this.props.firebase.auth.signInWithEmailAndPassword(email, password).then(result => {
                sessionStorage.setItem("UID", result.user.uid);
                console.log('result ' + result);
                this.setState({submitted: false, error: '', disabled: false, step: step + 1, loading: false});
            }).catch(error => {
                this.setState({submitted: false, disabled: false, error: error.message, loading: false});
                console.log('Error: ' + error.message)
            });
        }
    }

    logout() {
        this.props.firebase.auth.signOut().then(result => {
            sessionStorage.clear();
            this.setState({step: this.state.step - 1, email: '', password: ''});
        }).catch(error => {
            console.log("logout error " + error)
        });
    }

    render() {
        const {step, email, password, submitted, loading, error} = this.state;
        return (
            <div>
                {this.state.loading && <div class="cont-spinner">
                    <div class="lds-spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>}
                <div className="container">
                    {step === 0 && <Login email={email} password={password}
                                          submitted={submitted} loading={loading}
                                          error={error} handleSubmit={this.handleSubmit.bind(this)}
                                          handleChange={this.handleChange.bind(this)}/>}
                    {step === 1 && <div>
                        <div className="up_header">
                            <div className="logo"></div>
                            <Icon className="menu" onClick={this.logout.bind(this)} title="LOGOUT" type="logout"/>
                        </div>
                        <div className="header">
                            <Menu onClick={this.handleClick.bind(this)} selectedKeys={[this.state.current]}
                                  mode="horizontal">
                                <Menu.Item className="menu_item" key="upload">
                                    Inserisci Prodotti
                                </Menu.Item>
                                <Menu.Item className="menu_item" key="update">
                                    Visualizza Prodotti
                                </Menu.Item>

                            </Menu>
                        </div>
                        {this.state.current === 'upload' && <Insert
                            state={this.state}
                            props={this.props}/>}

                        {this.state.current === 'update' && <Update state={this.state} props={this.props}/>}

                    </div>}

                </div>
            </div>
        )
    }

}


Root.contextType = FirebaseContext;

export default Root;